import { LitElement, html, css } from "lit"

export class FrescoButton extends LitElement {
    static styles = css`
        a {
            position: relative;
            cursor: pointer;
            width: 100%;
            border-width: var(--btn-border-width);
            border-style: solid;
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            line-height: var(--btn-line-height);
            font-family: var(--btn-font-family);
            font-weight: var(--btn-font-weight);
            width: auto;
            overflow: hidden;
        }

        a:before {
            position: absolute;
            left: 50%;
            top: 100%; 
            transform: translate(-50%, 0);
            content: '';
            display: block;
            max-width: 40%;
            border-radius: 100%;
            transition: all 0.3s ease-out;
            aspect-ratio: 1 / 1;
            width: 200%;
            // background: black;
        }

        a:hover:before {
            max-width: 130%;
            top: 0;
            transform: translate(-50%, -50%);
            background: currentBackgroundColor;
        }

        span {
            position: relative;
            z-index: 1;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
        }

        :host {
        }
        
        :host([full]) {
        }
        
        /* Types */
        .primary {
            background: var(--btn-primary-bg);
            border: 1px solid var(--btn-primary-border);
            color: var(--btn-primary-color);
            &:before {
                background: var(--btn-primary-hover-bg);
            }
        }
        .primary:hover {
            // background: var(--btn-primary-hover-bg);
            border: 1px solid var(--btn-primary-hover-border);
            color: var(--btn-primary-hover-color);            
        }
        .primary:disabled {
            background: var(--btn-primary-disabled-bg);
            border: 1px solid var(--btn-primary-disabled-border);
            color: var(--btn-primary-disabled-color);
        }
        .primary:active {
            background: var(--btn-primary-active-bg);
            border: 1px solid var(--btn-primary-active-border);
            color: var(--btn-primary-active-color);
        }
        .primary:focus {
            background: var(--btn-primary-focus-bg);
            border: 1px solid var(--btn-primary-focus-border);
            color: var(--btn-primary-focus-color);
        }

        .secondary {
            background: var(--btn-secondary-bg);
            border: 1px solid var(--btn-secondary-border);
            color: var(--btn-secondary-color);
            &:before {
                background: var(--btn-secondary-hover-bg);
            }
        }
        .secondary:hover {
            // background: var(--btn-secondary-hover-bg);
            border: 1px solid var(--btn-secondary-hover-border);
            color: var(--btn-secondary-hover-color);            
        }
        .secondary:disabled {
            background: var(--btn-secondary-disabled-bg);
            border: 1px solid var(--btn-secondary-disabled-border);
            color: var(--btn-secondary-disabled-color);
        }
        .secondary:active {
            background: var(--btn-secondary-active-bg);
            border: 1px solid var(--btn-secondary-active-border);
            color: var(--btn-secondary-active-color);
        }
        .secondary:focus {
            background: var(--btn-secondary-focus-bg);
            border: 1px solid var(--btn-secondary-focus-border);
            color: var(--btn-secondary-focus-color);
        }

        .outline {
            background: var(--btn-outline-bg);
            border: 1px solid var(--btn-outline-border);
            color: var(--btn-outline-color);
            &:before {
                background: var(--btn-outline-hover-bg);
            }
        }
        .outline:hover {
            // background: var(--btn-outline-hover-bg);
            border: 1px solid var(--btn-outline-hover-border);
            color: var(--btn-outline-hover-color);            
        }
        .outline:disabled {
            background: var(--btn-outline-disabled-bg);
            border: 1px solid var(--btn-outline-disabled-border);
            color: var(--btn-outline-disabled-color);
        }
        .outline:active {
            background: var(--btn-outline-active-bg);
            border: 1px solid var(--btn-outline-active-border);
            color: var(--btn-outline-active-color);
        }
        .outline:focus {
            background: var(--btn-outline-focus-bg);
            border: 1px solid var(--btn-outline-focus-border);
            color: var(--btn-outline-focus-color);
        }

        .outline-white {
            background: var(--btn-outline-white-bg);
            border: 1px solid var(--btn-outline-white-border);
            color: var(--btn-outline-white-color);
            &:before {
                background: var(--btn-outline-white-hover-bg);
            }
        }
        .outline-white:hover {
            // background: var(--btn-outline-white-hover-bg);
            border: 1px solid var(--btn-outline-white-hover-border);
            color: var(--btn-outline-white-hover-color);            
        }
        .outline-white:disabled {
            background: var(--btn-outline-white-disabled-bg);
            border: 1px solid var(--btn-outline-white-disabled-border);
            color: var(--btn-outline-white-disabled-color);
        }
        .outline-white:active {
            background: var(--btn-outline-white-active-bg);
            border: 1px solid var(--btn-outline-white-active-border);
            color: var(--btn-outline-white-active-color);
        }
        .outline-white:focus {
            background: var(--btn-outline-white-focus-bg);
            border: 1px solid var(--btn-outline-white-focus-border);
            color: var(--btn-outline-white-focus-color);
        }

        .primary-gradient {
            background: var(--btn-primary-gradient-bg);
            border: 1px solid var(--btn-primary-gradient-border);
            color: var(--btn-primary-gradient-color);
            &:before {
                background: var(--btn-primary-gradient-hover-bg);
            }
        }
        .primary-gradient:hover {
            // background: var(--btn-primary-gradient-hover-bg);
            border: 1px solid var(--btn-primary-gradient-hover-border);
            color: var(--btn-primary-gradient-hover-color);            
        }
        .primary-gradient:disabled {
            background: var(--btn-primary-gradient-disabled-bg);
            border: 1px solid var(--btn-primary-gradient-disabled-border);
            color: var(--btn-primary-gradient-disabled-color);
        }
        .primary-gradient:active {
            background: var(--btn-primary-gradient-active-bg);
            border: 1px solid var(--btn-primary-gradient-active-border);
            color: var(--btn-primary-gradient-active-color);
        }
        .primary-gradient:focus {
            background: var(--btn-primary-gradient-focus-bg);
            border: 1px solid var(--btn-primary-gradient-focus-border);
            color: var(--btn-primary-gradient-focus-color);
        }

        /* Sizes */
        .small {
            font-size: var(--btn-small-font-mobile);
            padding: var(--btn-small-padding-y) var(--btn-small-padding-x);
            border-radius: var(--btn-small-radius);

            @media (min-width: 768px) {
                font-size: var(--btn-small-font-desktop);
            }
        }
        .medium {
            font-size: var(--btn-medium-font-mobile);
            padding: var(--btn-medium-padding-y) var(--btn-medium-padding-x);
            border-radius: var(--btn-medium-radius);

            @media (min-width: 768px) {
                font-size: var(--btn-medium-font-desktop);
            }
        }
        .large {
            font-size: var(--btn-large-font-mobile);
            padding: var(--btn-large-padding-y) var(--btn-large-padding-x);
            border-radius: var(--btn-large-radius);

            @media (min-width: 768px) {
                font-size: var(--btn-large-font-desktop);
            }
        }
        .full {
            font-size: var(--btn-large-font-mobile);
            padding: var(--btn-large-padding-y) var(--btn-large-padding-x);
            box-sizing: border-box;
            border-radius: var(--btn-large-radius);
            height: 100%;
            width: 100%;
        }
    `

    static properties = {
        full: { type: Boolean, reflect: true },
        type: { type: String },
        size: { type: String },
        link: { type: String },
        alt: { type: String },
        target: { type: String },
    };

    constructor() {
        super();
        this.full = false;
        // this.height = false;
        this.type = 'primary';
        this.size = 'medium';
        this.link = '#';
        this.alt = 'Botón o Enlace';
        this.target = '_blank';
    }

    render() {
        const classes = `${this.type} ${this.size}`
        return html`<a href=${this.link} target=${this.target} class=${classes} alt="${this.alt}"><span><slot></slot></span></a>`
    }
}

customElements.define('fresco-button', FrescoButton);